import {getHashQueryString} from 'jscommon/urlUtil.js';

//获取多语信息
export const getLocale = () => {
  let locale = getHashQueryString('locale');
  let currentLang = '';
  let switchLang = window.localStorage.switchLang;

  if (locale && locale !== 'null' && !switchLang) {
    locale = decodeURIComponent(locale);
    currentLang = locale || currentLang;
  } else {
    let language = (navigator.languages && navigator.languages[0]) ||
      navigator.language ||
      navigator.userLanguage;
    let languageWithoutRegionCode = language.toLowerCase().split(/[_-]+/)[0];

    if (!window.localStorage) {
      return languageWithoutRegionCode;
    }
    if (window.localStorage.lang) {
      //非法localstorage参数过滤
      let tmp = window.localStorage.lang;
      if (tmp.indexOf("zh_HK") == 0) {
        currentLang = "zh_TW";
      } else if (tmp.indexOf("zh_TW") == 0) {
        currentLang = "zh_TW";
      } else if (tmp.indexOf("zh") == 0) {
        currentLang = "zh_CN";
      } else if (tmp.indexOf("en") == 0) {
        currentLang = "en_US";
      } else {
        currentLang = null;
      }
    }

    currentLang = currentLang || languageWithoutRegionCode || 'zh_CN';
  }
  window.localStorage.lang = currentLang;

  return currentLang;
}

export const getCommmonLocale = () => {
  var currentLang = getLocale();
  var locale = currentLang || "zh_CN";
  var _locale;
  switch (locale) {
    case "zh": _locale = "ZH"; break;
    case "en": _locale = "EN"; break;
    case "zh_CN": _locale = "ZH"; break;
    case "en_US": _locale = "EN"; break;
    default: _locale = locale; break;
  }
  return _locale;
}

export const getCalendarLocale = () => {
  var currentLang = getLocale();
  var locale = currentLang || "zh_CN";
  var _locale;
  switch (locale) {
    case "zh": _locale = "zh_CN"; break;
    case "en": _locale = "en_US"; break;
    case "zh_CN": _locale = "zh_CN"; break;
    case "en_US": _locale = "en_US"; break;
    case "zh_HK": _locale = "zh_TW"; break;
    case "zh_TW": _locale = "zh_TW"; break;
    default: _locale = locale; break;
  }
  return _locale;
}


export const getLocaleType = () => {
  var currentLang = getLocale();
  var localeStr = null;
  if (currentLang.indexOf('zh_HK') !== -1) {
    localeStr = 'zh_TW';
  } else if (currentLang.indexOf('zh_TW') !== -1) {
    localeStr = 'zh_TW';
  } else if (currentLang.indexOf('zh') !== -1) {
    localeStr = 'zh_CN';
  } else if (currentLang.indexOf('en') !== -1) {
    localeStr = 'en';
  }
  return localeStr;
}



